module.exports = __webpack_public_path__ + "static/media/file-word.60e0053c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/file-word.svg
// module id = 2871
// module chunks = 7